var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M643.2,577.9h-47.2c-13.1,0-22.2-13-17.8-25.3l33.9-93.9c2.7-7.5,9.8-12.5,17.8-12.5h47.2c13.1,0,22.2,13,17.8,25.3 l-33.9,93.9C658.2,572.9,651.1,577.9,643.2,577.9L643.2,577.9z M802.4,541.6l42.5-117.5c4.5-12.3-4.7-25.3-17.8-25.3h-47.2 c-8,0-15,5-17.8,12.5l-42.5,117.5c-4.5,12.3,4.7,25.3,17.8,25.3h47.2C792.6,554.1,799.7,549.1,802.4,541.6z M842.8,625.4H890 c8,0,15-5,17.8-12.5L976,424.1c4.5-12.3-4.7-25.3-17.8-25.3H911c-8,0-15,5-17.8,12.5L825,600.1C820.6,612.4,829.7,625.4,842.8,625.4 L842.8,625.4z M529.8,565.5l33.9-93.9c4.5-12.3-4.7-25.3-17.8-25.3h-47.2c-8,0-15,5-17.8,12.5l-33.9,93.9 c-4.5,12.3,4.7,25.3,17.8,25.3h47.3C520,577.9,527.1,572.9,529.8,565.5z M398.7,565.5l33.9-93.9c4.5-12.3-4.7-25.3-17.8-25.3h-47.2 c-8,0-15,5-17.8,12.5L316,552.6c-4.5,12.3,4.7,25.3,17.8,25.3H381C388.9,577.9,396,572.9,398.7,565.5z M179.2,625.4h47.2 c7.9,0,15.1-5,17.8-12.5l68.2-188.8c4.5-12.3-4.7-25.3-17.8-25.3h-47.2c-7.9,0-15.1,5-17.8,12.5l-68.2,188.8 C157,612.4,166.1,625.4,179.2,625.4L179.2,625.4z M130.8,541.6l42.4-117.4c4.4-12.3-4.7-25.3-17.8-25.3h-47.2 c-7.9,0-15.1,5-17.8,12.5L48,528.8c-4.5,12.3,4.7,25.3,17.8,25.3H113C121,554.1,128.1,549.1,130.8,541.6L130.8,541.6z M712.6,625.4 h47c7.9,0,14.9-4.9,17.7-12.2l0,0c4.7-12.3-4.5-25.5-17.7-25.5h-47c-7.9,0-14.9,4.9-17.7,12.2l0,0 C690.3,612.2,699.5,625.4,712.6,625.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBk);
export default __webpack_public_path__ + "static/media/logo-bk.fb97a8d199b8b09a0595282883cbeb7b.svg";
export { ForwardRef as ReactComponent };